export default "__VITE_ASSET__iuO_S9P0__"